import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CCol,
  CButton,
  CRow,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CTabs,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CTooltip,
  CPagination,
  CPopover
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import ApplicatedQuestionList from "../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../components/Breadcrumb";
import Cards from "../../../components/Cards/Cards";
import TextCreator from "../../../components/Content/TextCreator";
import CorrectLiterarte from "../../../components/CorrectLiterarte";
import Interface from "../../../components/Interface";
import LiterarteModal from "../../../components/LiterarteModal";
import Loading from "../../../components/Loading";
import ModalTools from "../../../components/ModalTools";
import ProtectedRoute from "../../../components/ProtectedRoute";
import RichText from "../../../components/RichText/SlateEditor/Editor";
import ShareModal from "../../../components/ShareModal";
import ListaNotasFiltro from "../../../components/Statistics/Comparison/ListaNotasFiltro";
import Statistics from "../../../components/Statistics/StatisticsActivityDo/statisticsActivityDo";
import Students from "../../../components/Students/Students";
import UploadModal from "../../../components/UploadModal";
import Widgets from "../../../components/Widgets/Widgets";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { baseDate } from "../../../utils/date";
import { caminhoDoLo } from "../../../utils/loSingleView";
import EvaluationStatistics from "../../Activity/Activity/Do/evaluationStatistics";

const FileDownload = require("js-file-download");

// role_id 7 = aluno, o mesmo número usado em layout/Sidebar.js.
const ROLE_ALUNO = 7;

class OlympicsActivity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activity: null,
      activity_id: this.props.match.params.id,
      activity_name: "",
      loading: true,
      iframe: false,
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      correctLiterarte: {
        id: "",
        show: false
      },
      youtubeModal: {
        show: false,
        title: "",
        urlID: ""
      },
      contentId: "",
      contentName: "",
      uploadModal: false,
      shareModal: false,
      item_id: null,
      literarteStart: null,
      url: null,
      textModal: false,
      lo_id: null
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.verifyPermission(() =>
      this.handleActivity(() => this.initializeActivity())
    );
  }

  createExecution(callback = () => null) {
    const obj = {
      activity_id: this.state.activity_id
    };

    axios
      .post(`${URL.api}activity/execution/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ execution_id: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      });
  }

  verifyPermission(callback = () => {}) {
    axios
      .get(
        `${URL.api}olympics/activity/verifypermission/${this.state.activity_id}`,
        {
          headers: {
            authorization: `Bearer ${this.props.user.token}`,
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(resp => {
        if (resp.data.success) {
          this.setState(
            {
              allocation: resp.data.data.allocation,
              olympics_id: resp.data.data.olympics_id
            },
            () => callback()
          );
        } else {
          this.error("Falha ao verificar permissões!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao verificar permissões!");
        }
      });
  }

  handleActivity(callback = () => null) {
    this.createExecution(() => {
      axios
        .get(
          `${URL.api}activity/activity/singleViewByExecution/${this.state.execution_id}`,
          {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          }
        )
        .then(resp => {
          if (resp.data.success) {
            const activity = {
              ...resp.data.data,
              items: resp.data.data.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };
            this.setState(
              {
                activity,
                itens: activity.items,
                evaluation_id_json: resp.data.data.evaluation_id_json
                // executionQuantity: resp.data.data.executionQuantity
              },
              () => {
                callback();
              }
            );
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.error("Sua sessão expirou!");
            this.props.logout();
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        });
    });
  }

  initializeActivity() {
    const objExecutionItem = { activity_id: this.state.activity.id };

    axios
      .post(`${URL.api}activity/execution/item/list`, objExecutionItem, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(respExecutionItem => {
        // listar itens
        let listQuestion = {
          id: "",
          show: false,
          average: 0,
          time: null
        };

        const activity = {
          // eslint-disable-next-line react/no-access-state-in-setstate
          ...this.state.activity,
          // eslint-disable-next-line react/no-access-state-in-setstate
          items: this.state.activity.items.map(item => ({
            ...item,
            title: item.name,
            subtitle: item.type_name
          }))
        };
        this.setState({
          loading: false,
          activity,
          activity_id: activity.id,
          activity_name: activity.name,
          activity_description_box: {
            type: 0,
            text: activity.description
          },
          itens: activity.items
        });
      })
      .catch(() => {
        this.error("Não foi possível obter informações sobre a atividade");
      });
  }

  createItemExecution(item, finished, callback = () => null, percentage) {
    const late = Date.parse(this.state.activity.activity_end) < Date.now();

    if (finished || late) {
      callback();
      return;
    }

    const obj = {
      execution_id: this.state.execution_id,
      item_id: item,
      completion_percentage: percentage,
      start: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString(),
      end: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString(),
      olympics_id: this.state.olympics_id
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          callback();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      });
  }

  openItem = item => {
    const late = Date.parse(this.state.activity.activity_end) < Date.now();

    const tryCreateItemExecution = (percentage = 100) => {
      if (item.id) {
        this.createItemExecution(
          item.id,
          item.item_percentage === 100,
          () => this.handleActivity(),
          percentage
        );
      }
    };

    if (item.type_id === 12) {
      const url = `http://avaliacao.educandus.com.br:3000/external_auth?token=${
        this.props.user.token
      }
        &evaluationIdJson=${this.state.evaluation_id_json}
        &listId=${item.obj_id}
        &allocationId=null
        &try=${1}
        &source=${`olympics-${this.state.olympics_id}`}
        `;
      window.location.href = url;
    } else if (item.type_id === 16 || item.type_id === 27) {
      // LINK
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            window.open(caminhoDoLo(resp), "_blank");
            tryCreateItemExecution();
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (item.type_id === 33) {
      this.setState({ lo_id: item.obj_id, textModal: true });
      tryCreateItemExecution();
    } else if (item.type_id === 14) {
      // LITERARTE
      if (late && item.item_percentage !== 100) {
        toastr.warning("Atenção", "A atividade já foi encerrada!");
        return;
      }

      this.setState(prevState => ({
        textProduction: {
          ...prevState.textProduction,
          show: true,
          id: item.obj_id
        },
        item_id: item.id,
        contentName: item.title,
        literarteStart: new Date()
      }));
    } else if (item.type_id === 18) {
      // Espelha o Do/index.jsx: o papel que vale é o ATIVO. O teste antigo,
      // `user.user_roles[0].role_name === "Aluno"`, olhava o primeiro vínculo
      // da lista e engolia o clique de quem tem mais de um.
      if (this.props.general.active_roles.role_id !== ROLE_ALUNO) {
        toastr.info(
          "Upload do aluno",
          "Este item é uma entrega de arquivo do aluno."
        );
      } else if (item.item_percentage === 100) {
        toastr.info(
          "Item realizado",
          item.item_grade
            ? `Você tirou a nota ${item.item_grade}`
            : "A correção ainda não está disponível"
        );
      } else {
        this.setState({
          uploadModal: true,
          contentId: item.obj_id,
          contentName: item.title,
          item_id: item.id
        });
      }
    } else if (item.type_id !== 17) {
      tryCreateItemExecution();
      this.setState({
        iframe: true,
        contentId: item.obj_id,
        contentName: item.title,
        item_id: item.id
      });
    } else {
      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);

          tryCreateItemExecution();
        });
    }
  };

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: this.state.textProduction.id,
      pages: pagesObj,
      item_id: this.state.item_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Sucesso", "O texto foi salvo.");
          this.setState({
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              show: false
            }
          });
        }
      });
  };

  render() {
    const late =
      !this.state.loading &&
      new Date(this.state.activity?.activity_end) < new Date();

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: "/classroom/me", to: "/classroom/me" },
            {
              path: "/classroom/:id/activities",
              to: `/classroom/${this.state.activity?.room_id}/activities`
            }
          ]}
        />

        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() =>
              this.setState({ iframe: false }, () => this.handleActivity())
            }
            aula={this.state.contentId}
            atividade={this.state.activity_id}
            act_item_id={this.state.item_id}
            act_execution_id={late ? undefined : this.state.execution_id}
            currentRoute={this.props.currentRoute}
            url={!this.state.contentId && this.state.url}
          />
        )}
        <ShareModal
          show={this.state.shareModal}
          onClose={() => this.setState({ shareModal: false })}
          link={window.location.href}
        />
        {this.state.uploadModal && (
          <UploadModal
            onClose={() =>
              this.setState({ uploadModal: false }, () => this.handleActivity())
            }
            upload_id={this.state.contentId}
            activity_id={this.state.activity_id}
            item_id={this.state.item_id}
            execution_id={this.state.execution_id}
          />
        )}
        {this.state.textProduction.id !== "" ? (
          <LiterarteModal
            id={this.state.textProduction.id}
            user_id={this.props.user.user.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                {
                  textProduction: {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state.textProduction,
                    show: false
                  }
                },
                () => this.handleActivity()
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              })
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
          />
        ) : null}
        {this.state.correctLiterarte && (
          <CorrectLiterarte
            id={this.state.correctLiterarte.id}
            show={this.state.correctLiterarte.show}
            onClose={() =>
              this.setState({
                correctLiterarte: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.correctLiterarte,
                  show: false
                }
              })
            }
            user_id={this.props.user.user.id}
          />
        )}
        {this.state.textModal && (
          <TextCreator
            show={this.state.textModal}
            onClose={() =>
              this.setState({
                textModal: false
                // currentLOLink: null
              })
            }
            // eslint-disable-next-line react/jsx-boolean-value
            showOnly={true}
            currentLOLink={this.state.lo_id}
          />
        )}
        <CModal
          show={this.state.youtubeModal.show}
          onClose={() =>
            this.setState(prevState => ({
              youtubeModal: {
                ...prevState.youtubeModal,
                show: false,
                urlID: ""
              }
            }))
          }
          size="lg w-100 h-100 m-0 p-5 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop
        >
          <CModalHeader>
            <CModalTitle>{this.state.youtubeModal.title}</CModalTitle>
            <button
              onClick={() =>
                this.setState(prevState => ({
                  youtubeModal: {
                    ...prevState.youtubeModal,
                    show: false
                  }
                }))
              }
            >
              <i className="fa fa-close text-secondary"></i>
            </button>
          </CModalHeader>
          <CModalBody>
            <iframe
              title="youtube"
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${this.state.youtubeModal.urlID}?autoplay=0`}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              // style={{ minHeight: "80vh" }}
            ></iframe>
          </CModalBody>
          <CModalFooter>
            <a
              href={`https://youtu.be/${this.state.youtubeModal.urlID}`}
              target="_blank"
              rel="noreferrer"
            >
              Abrir link em outra guia
              <i className="fa fa-external-link ml-1"></i>
            </a>
          </CModalFooter>
        </CModal>
        {!this.state.loading ? (
          <>
            <CTabs activeTab="activity">
              <CNav variant="tabs">
                <CNavItem>
                  <CNavLink data-tab="activity">Atividade</CNavLink>
                </CNavItem>
                {this.props.user.user_roles[0].role_id !== 7 && (
                  <CNavItem>
                    <CNavLink data-tab="students">Estudantes</CNavLink>
                  </CNavItem>
                )}
              </CNav>
              <CTabContent>
                <CTabPane data-tab="activity">
                  <CRow className="d-flex align-items-center justify-content-between">
                    <CCol xs="12" md="6" className="mb-2 mb-md-0">
                      <h4 className="m-0">
                        <strong>{this.state.activity_name}</strong>
                      </h4>
                    </CCol>
                    <CCol
                      xs="12"
                      md="6"
                      className="d-flex align-items-center justify-content-between"
                    >
                      <div className="d-flex flex-column">
                        <span>
                          <strong>Início</strong>
                        </span>
                        <p className="m-0">
                          {
                            this.state.allocation.allocation_start
                              .split(" ")[0]
                              .split("-")[2]
                          }
                          /
                          {
                            this.state.allocation.allocation_start
                              .split(" ")[0]
                              .split("-")[1]
                          }
                          /
                          {
                            this.state.allocation.allocation_start
                              .split(" ")[0]
                              .split("-")[0]
                          }{" "}
                          {this.state.allocation.allocation_start.split(" ")[1]}
                        </p>
                      </div>
                      <div className="d-flex flex-column ml-3">
                        <span>
                          <strong>Final:</strong>
                        </span>
                        <p className="m-0">
                          {
                            this.state.allocation.allocation_end
                              .split(" ")[0]
                              .split("-")[2]
                          }
                          /
                          {
                            this.state.allocation.allocation_end
                              .split(" ")[0]
                              .split("-")[1]
                          }
                          /
                          {
                            this.state.allocation.allocation_end
                              .split(" ")[0]
                              .split("-")[0]
                          }{" "}
                          {this.state.allocation.allocation_end.split(" ")[1]}
                        </p>
                      </div>
                    </CCol>
                  </CRow>
                  <hr />

                  {this.state.activity_description_box.type === 1 ? (
                    <div className="row align-items-center">
                      <div className="col-9">
                        <h2>{this.state.activity_description_box.title}</h2>
                        <h6>
                          <small>
                            {this.state.activity_description_box.subtitle}
                          </small>
                        </h6>
                      </div>
                      <div className="col-3">
                        <button
                          className="btn btn-primary"
                          type="button"
                          style={{ float: "right" }}
                        >
                          {this.state.activity_description_box.text_button}
                        </button>
                      </div>
                    </div>
                  ) : this.state.activity_description_box.type === 2 ? (
                    <div>
                      {this.state.activity_description_box.items?.length ? (
                        this.state.activity_description_box.items.map(
                          (item, index) => (
                            <div key={index} className="cards-activity-item">
                              <div className="d-flex align-items-center">
                                <div
                                  className={`cards-activity-icon-container${
                                    item.activity_percentage
                                      ? " done"
                                      : new Date(item.activity_end) < new Date()
                                      ? " late"
                                      : ""
                                  }`}
                                >
                                  <i className="fa fa-line-chart"></i>
                                </div>
                              </div>
                              <div
                                className="d-flex flex-column justify-content-center"
                                style={{ flex: 1 }}
                              >
                                <div
                                  className="cards-activity-title"
                                  onClick={() =>
                                    this.props.function(item.allocation_id)
                                  }
                                >
                                  {item.name}
                                </div>
                                <div className="d-flex">
                                  <span className="small text-muted">
                                    {item.activity_percentage
                                      ? "Concluída"
                                      : new Date(item.activity_end) < new Date()
                                      ? "Atrasada"
                                      : "A fazer"}
                                  </span>
                                  {item.activity_percentage ? (
                                    <span className="small text-success ml-1">
                                      ({item.activity_percentage}%)
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhuma atividade a ser mostrada
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 3 ? (
                    <div>
                      {this.state.activity_description_box.items?.length ? (
                        this.state.activity_description_box.items.map(
                          (item, index) => (
                            <div key={index} className="cards-discussion-item">
                              <div className="d-flex align-items-center cards-discussion-avatar">
                                <div
                                  className="img-fluid"
                                  style={{
                                    width: "100%",
                                    paddingTop: "100%",
                                    backgroundImage: `url("${URL.img}${
                                      item.user_photo ||
                                      "uploads/users/profileEmpty.jpg"
                                    }")`,
                                    backgroundSize: "100% 100%",
                                    borderRadius: "100%"
                                  }}
                                ></div>
                              </div>
                              <div
                                className="d-flex flex-column justify-content-center text-ellipsis"
                                style={{ flex: 1 }}
                              >
                                <div
                                  className="cards-discussion-title text-ellipsis"
                                  onClick={() => this.props.function(item.id)}
                                >
                                  {item.title}
                                </div>
                                <span className="small text-muted text-ellipsis">
                                  {item.description}
                                </span>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhuma discussão a ser mostrada
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 4 ? (
                    <div>
                      {this.state.activity_description_box.items?.length ? (
                        <div
                          className="row justify-content-center"
                          style={{ marginBottom: "-15px" }}
                        >
                          {this.state.activity_description_box.items.map(
                            (item, index) => (
                              <div
                                key={index}
                                className="col-4"
                                style={{ marginBottom: "15px" }}
                              >
                                <CTooltip
                                  content={item.user_name}
                                  placement="top"
                                >
                                  <div
                                    className="img-fluid"
                                    style={{
                                      cursor: "pointer",
                                      paddingTop: "100%",
                                      backgroundImage: `url("${URL.img}${
                                        item.user_photo ||
                                        "uploads/users/profileEmpty.jpg"
                                      }")`,
                                      backgroundSize: "100% 100%",
                                      borderRadius: "100%"
                                    }}
                                    onClick={() =>
                                      this.props.history.push(
                                        `/profile/${item.user_id}`
                                      )
                                    }
                                  ></div>
                                </CTooltip>
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhum membro a ser mostrado
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 5 ? (
                    <div>
                      {this.state.activity_description_box.items.length ? (
                        <div
                          className="row"
                          style={{
                            marginBottom: "-0.5rem",
                            marginTop: "-0.5rem",
                            marginLeft: "-0.5rem",
                            marginRight: "-0.5rem"
                          }}
                        >
                          {this.state.activity_description_box.items.map(
                            (item, index) => (
                              <CCol
                                sm={6}
                                key={index}
                                style={{
                                  marginBottom: "0.5rem",
                                  marginTop: "0.5rem",
                                  paddingLeft: "0.5rem",
                                  paddingRight: "0.5rem"
                                }}
                              >
                                <CCard
                                  className={`m-0 ${
                                    this.state.docSelected === item.id
                                      ? "doc-selected"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.setState({ docSelected: item.id })
                                  }
                                  onDoubleClick={() =>
                                    this.props.openUrl(item.name, item.link)
                                  }
                                >
                                  <CCardBody
                                    style={{
                                      pointerEvents: "none",
                                      userSelect: "none"
                                    }}
                                  >
                                    <div className="text-ellipsis text-center">
                                      <i className="fa fa-file text-danger mr-3"></i>
                                      {item.name}
                                    </div>
                                  </CCardBody>
                                </CCard>
                              </CCol>
                            )
                          )}
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhum documento a ser mostrado
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 6 ? (
                    <div>
                      {this.state.activity_description_box.items.length ? (
                        <div
                          className="row"
                          style={{
                            marginBottom: "-0.5rem",
                            marginTop: "-0.5rem",
                            marginLeft: "-0.5rem",
                            marginRight: "-0.5rem"
                          }}
                        >
                          {this.state.activity_description_box.items.map(
                            (item, index) => (
                              <CCol
                                sm={6}
                                key={index}
                                style={{
                                  marginBottom: "0.5rem",
                                  marginTop: "0.5rem",
                                  paddingLeft: "0.5rem",
                                  paddingRight: "0.5rem"
                                }}
                              >
                                <CCard
                                  className={`m-0 ${
                                    this.state.docSelected === item.id
                                      ? "doc-selected"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.setState({ docSelected: item.id })
                                  }
                                  onDoubleClick={() =>
                                    this.props.function(item.link)
                                  }
                                >
                                  <CCardBody
                                    style={{
                                      pointerEvents: "none",
                                      userSelect: "none"
                                    }}
                                  >
                                    <div className="text-ellipsis text-center">
                                      <i className="fa fa-video-camera mr-3"></i>
                                      {item.activity_name
                                        ? `Gravação de ${item.activity_name}`
                                        : decodeURIComponent(
                                            item.link.split("/").splice(-1)[0]
                                          )}
                                    </div>
                                  </CCardBody>
                                </CCard>
                              </CCol>
                            )
                          )}
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhuma gravação a ser mostrada
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {this.state.activity_description_box.text !==
                      undefined ? (
                        this.state.activity_description_box.text.substring(
                          0,
                          1
                        ) === "[" ? (
                          <RichText
                            description={
                              this.state.activity_description_box.text
                            }
                            editavel={false}
                          />
                        ) : (
                          <div>{this.state.activity_description_box.text}</div>
                        )
                      ) : (
                        <div></div>
                      )}
                    </>
                  )}

                  <h5 className="mt-3">
                    <strong>Objetos</strong>
                  </h5>
                  <hr />
                  {new Date(this.state.allocation.allocation_start) >
                  new Date() ? (
                    <CRow className="flex-1">
                      <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                        <img
                          src={ImgNoData}
                          style={{
                            height: "240px",
                            marginBottom: "2rem"
                          }}
                          alt=""
                        />
                        <p
                          style={{ fontSize: "1.5rem" }}
                          className="mb-2 font-weight-bold text-center"
                        >
                          A atividade ainda não foi liberada
                        </p>
                        <span className="text-muted text-center">
                          Tente voltar daqui a alguns minutos
                        </span>
                      </div>
                    </CRow>
                  ) : (
                    <CRow className="flex-1">
                      {this.state.itens.length > 0 ? (
                        <CCol lg="12">
                          <div id="leftSide">
                            <Widgets
                              itens={this.state.itens}
                              openItem={this.openItem}
                              sequentialExecution={
                                this.state.activity.sequential_execution
                              }
                              completionMark
                              source="olympics"
                            />
                          </div>
                        </CCol>
                      ) : (
                        <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                          <img
                            src={ImgNoData}
                            style={{
                              height: "240px",
                              marginBottom: "2rem"
                            }}
                            alt=""
                          />
                          <p
                            style={{ fontSize: "1.5rem" }}
                            className="mb-2 font-weight-bold text-center"
                          >
                            Nenhum conteúdo foi liberado
                          </p>
                          <span className="text-muted text-center">
                            Entre em contato com seu professor
                          </span>
                        </div>
                      )}
                    </CRow>
                  )}
                </CTabPane>
              </CTabContent>
            </CTabs>
          </>
        ) : (
          <Loading top="45" left="50" />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OlympicsActivity);
